import styled from '@emotion/styled'
import { Container, Dropdown, List, Input, GridColumn } from 'semantic-ui-react'
import { H6, Paragraph1 } from '@styles/Global.styles';
import theme from '@styles/theme';
import mq from '@styles/mq';
//import Hyperlink from '@components/elements/Hyperlink/Hyperlink';
import React from 'react';
import { Hyperlink } from '../elements';

//(Container)<{isMobile: boolean | undefined, darkThem:boolean}>
export const DetailContainer = styled(({...rest}) => <Container {...rest} />) `
    &&&&{
        padding-top: ${p => (p.isMobile ? "10px" : "40px")};
        color:${p => p.darkTheme ? 'white' : 'black'};
        ${mq({
    paddingLeft: ['0px', '10px', '10%'],
    marginLeft: ['0 !important', '0', '0'],
    marginRight: ['0 !important', '0', '0']
})}
    }

    #pdd-gift-box > span > .button{
        ${mq({
            marginTop: ['12px', '0px', '0px'],
        })};       
    }
        #pdd-gift-box > span > .ui.button > .icon:not(.button){
         opacity: 1;
        }
 `

 export const DetailHeading = styled.div<{isMobile: boolean | undefined}>`
    text-align: ${p => (p.isMobile ? "center" : "left")};
    padding-bottom: 6px;
`
export const DealerLink = styled.span`
    color: ${theme.brand.primary};
    text-decoration: "underline";
    cursor: pointer;
    :hover{
        color: ${theme.brand.primary};
    }
`

export const PlateDesignPricing = styled.div<{isMobile: boolean | undefined}>`
    padding-bottom: ${p => (p.isMobile ? "0px" : "10px")};
`

export const PricingFrom = styled.span`
    vertical-align: top;
    text-align: left;
    font-weight: light;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.32px;
    color: #B7B7B7
`
export const InfoBannerInfoContainer = styled(Container)`
    padding-left: 15%;
`
export const BannerPricingAmount = styled.span`
    vertical-align: top;
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color: #3DAE2B;
`
export const PriceLoadingMessage = styled.span`
    height: 32px;
    font-size: 16px;
    line-height: 34px;
`
export const PricingAmount = styled.span`
    vertical-align: top;
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    line-height: 34px;
    color: #3DAE2B;
`

export const Description = styled(Paragraph1)`
    padding-bottom: 10px;
    figure {
        margin: 0;
    }
`

export const ColorPaletteContainer = styled.div`
`

export const PlateDesignSizes = styled.div`
    padding-top: 24px;
`
export const MessageLocationWrapper = styled.div`
`
export const PlateSizeHeading = styled.div`
    display: block;
    clear: both;
    padding-bottom: 6px;
`
export const LockedMessageSpacing = styled.div`
    padding-bottom: 24px;
`
export const PlateSizeTitle = styled(({...rest}) => <H6 {...rest} />)`
    float: left;
    padding-bottom: 6px;
    color: ${p => (p.darkTheme ? 'white' : 'black')};
`
export const KpPlateMessageInput = styled(Input)`
    clear: both;
    height: 50px;
    > input{
        font-family: 'message_plate_fontregular' !important;
        font-size: 16px !important;
    }
`
export const PlateSizeSubtitle =  styled(({...rest}) => <span {...rest} />)`
    ${mq({
    fontSize: ['14px', '16px', '16px'],
})}
    float: right;
    text-align: left;
    font-weight: light;
    line-height: 22px;
    letter-spacing: -0.32px;
    color: ${p => (p.darkTheme ? theme.brand.colors.lightToGrey : theme.brand.colors.darkGrey)};
`

export const PlateSizeDropdown = styled(Dropdown)`

`
export const PlateBrandsDropdown = styled(Dropdown)`
`
export const MessagePlateSectionContainer = styled(({...rest}) => <div {...rest} />)`
    padding-top: 30px;
    padding-bottom: 24px;
    border-bottom: 2px solid ${theme.brand.colors.darkGrey};
    color:${p => (p.darkTheme ? 'white' : 'black')};
`
export const CaptionPositionWrapper = styled.div`
    padding-top: 24px;
    padding-bottom: 30px;
    border-bottom: 2px solid ${theme.brand.colors.darkGrey};
`
export const ErrorHeading = styled.div`
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    letter-spacing: -0.32px;
    color: ${theme.brand.colors.error}
`
export const DealerListItem = styled(List.Item)`
    border-bottom: 2px solid ${theme.brand.colors.lightGrey};
`
export const DealerContact = styled.div`
    float: left;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    padding: 12px 0 12px 0;
    & > span {
        color: ${theme.brand.colors.darkGrey};
        font-weight: normal;
        display: block;
    }
`
export const DealerPhone = styled.div`
    float: right;
    padding: 12px 0 12px 0;
`

export const PlateSizeDropdownContainer = styled(GridColumn)`
    margin-bottom: 15px !important;
`

export const PlateHoleGuideLink = styled(Hyperlink)`
    color: ${theme.brand.colors.green};
    display: block;
    margin-bottom: 25px;
    font-size: 12px;
    text-decoration: none;

    &:hover {
        color: ${theme.brand.colors.green};
        text-decoration: underline;
    }
`